module.exports = __webpack_public_path__ + "static/media/imgop_renewable_heat.97927f63.webp";